import {
    Message
} from "element-ui";
import {
    getAnalystRatingCategoryList,
    getAnalystRatingFundCategoryList
} from "../../../api/analystRating";
const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;

export const fiterCategory = {
    data() {
        return {
            filteredCategoryList: [],
            categoryList: []
        }
    },
    methods: {
        fiterCategory(query) {
            const self = this;
            if (query !== "") {
                self.filteredCategoryList = self.categoryList.filter(item => {
                    return (
                        item.categoryNamePhonetic
                        .toLowerCase()
                        .indexOf(query.toLowerCase()) > -1 ||
                        item.categoryName.indexOf(query) > -1
                    );
                });
            } else {
                self.filteredCategoryList = self.categoryList;
            }
        },
        handleCategory() {
            const self = this;
            getAnalystRatingCategoryList()
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message: "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                self.categoryList = self.filteredCategoryList =
                                    result.data.categoryList;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {});
        },
        handleFundCategory() {
            const self = this;
            getAnalystRatingFundCategoryList()
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message: "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                self.categoryList = self.filteredCategoryList =
                                    result.data.categoryList;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {});
        },
    }
}
